<template>
  <div class="login-header">
    <div class="header-content">
      <div class="logo-container">
        <img :src="logoPath" class="logo-img" alt="CPS+ eMarketplace" @click="handleLogoClick" />
      </div>
      <div class="header-right">
        <!-- Admin Account Icon and Text (可点击) - 只有admin或member才显示 -->
        <div v-if="isShowMyAccountIcon" class="admin-account-wrapper" @click="goToMyAccount">
          <div class="admin-account-icon">
            <img 
              src="https://cdn.adsalecdn.com/EMP/Backend/Images/Account%20circle.png" 
              alt="My Account" 
              class="account-circle-img"
            />
          </div>
          <div class="my-account-text">
            {{ $t('lbl_emp2_MyAccount') }}
          </div>
        </div>
        <div class="language-selector">
          <slot name="language">
            <language variant="white"></language>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginHeader',
  props: {
    logoPath: {
      type: String,
      required: true
    }
  },
  computed: {
    currentLang() {
      return localStorage.getItem('currentLang') || 'simp';
    },
    user() {
      // 使用 computed 属性来确保响应式更新
      return this.$store?.state?.authentication?.user;
    },
    isShowMyAccountIcon() {
      // 统一使用 userRole 字段判断，与右上角 empProfile 组件保持一致的逻辑
      // 只有 admin 或 member 角色才显示 MyAccount
      if (!this.user?.userRole) {
        return false;
      }
      const role = String(this.user.userRole).toLowerCase();
      return role === 'admin' || role === 'member';
    }
  },
  methods: {
    handleLogoClick() {
      // 获取当前URL的查询参数，保留regsource等重要参数
      const currentQuery = this.$route.query || {};
      const queryParams = new URLSearchParams();
      
      // 保留regsource参数
      if (currentQuery.regsource) {
        queryParams.set('regsource', currentQuery.regsource);
      }
      
      // 设置语言参数
      queryParams.set('lang', this.currentLang);
      
      // 根据环境构建基础URL
      const envName = process.env.VUE_APP_EMP_ENV_NAME || '';
      let baseUrl = 'https://www.chinaplasonline.com/eMarketplace/SupplierCentre/auth/login';
      if (envName.toLowerCase() === 'uat') {
        baseUrl = 'https://www.chinaplasonline.com/eMarketplaceUAT/SupplierCentre/auth/login';
      } else if (envName.toLowerCase() === 'ai') {
        baseUrl = 'https://www.chinaplasonline.com/eMarketplaceAI/SupplierCentre/auth/login';
      }
      
      window.location.href = `${baseUrl}?${queryParams.toString()}`;
    },
    goToMyAccount() {
      this.$router.push({ name: 'MyAccount' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('跳转到 MyAccount 失败:', err);
        }
      });
    }
  }
};
</script>

<style scoped>
.login-header {
  width: 100%;
  min-height: 110px;
  max-height: 110px;
  height: 110px;
  padding: 24px;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  box-sizing: border-box;
}

.header-content {
  align-self: stretch;
  flex: 1 1 0;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.language-selector {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-img {
  max-width: 200px;
  height: auto;
  cursor: pointer;
}

.admin-account-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.admin-account-wrapper:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.admin-account-icon {
  display: flex;
  align-items: center;
}

.account-circle-img {
  width: 21px;
  height: 21px;
  object-fit: contain;
}

.my-account-text {
  color: white;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  white-space: nowrap;
}
</style>

